import { Menu } from 'antd';
import type { FC, ReactNode } from 'react';
import React, { useCallback, useEffect, useState } from 'react';

import type { EntityConnectProps } from 'app/redux/entityConnect';
import { entityConnect } from 'app/redux/entityConnect';
import type { ICountry } from 'app/typings';

import { ListPage } from './ListPage';

const CountryListPageComponent: FC<Props> = ({
  title,
  countries,
  fetchEntities,
  children,
}) => {
  useEffect(() => {
    fetchEntities();
  }, [fetchEntities]);

  const [countryId, setCountryId] = useState(1);

  const handleChangeTab = useCallback(({ key }: { key: string }) => {
    setCountryId(+key);
  }, []);

  return (
    <ListPage
      title={title}
      menu={
        <Menu
          mode="horizontal"
          onClick={handleChangeTab}
          selectedKeys={[countryId.toString()]}
          items={countries?.map((c) => ({
            key: c.id.toString(),
            label: c.name,
          }))}
        />
      }
    >
      {children({ countryId })}
    </ListPage>
  );
};

type ChildProps = {
  countryId: number;
};

type ConnectedProps = {
  countries: ICountry[];
};

type OwnProps = {
  title: string;
  children: (props: ChildProps) => ReactNode;
};

type Props = EntityConnectProps<ConnectedProps, OwnProps>;

export const CountryListPage = entityConnect<ConnectedProps, OwnProps>([
  'countries',
])(CountryListPageComponent);
